/**
 * Leadmagnet – theme behaviour
 * Used by snippets/leadmagnet.liquid (rendered from sections/header.liquid + snippets/menu-drawer.liquid)
 */
(function () {
  'use strict';

  var VERSION = '1.1.0';
  var DEFAULT_COOKIE_NAME = 'leadmagnet_minimized';
  var MAX_MINIMIZE_DAYS = 365;

  function sanitizeCookieName(name) {
    if (!name || typeof name !== 'string') return DEFAULT_COOKIE_NAME;
    var sanitized = name.replace(/[^a-zA-Z0-9_-]/g, '');
    if (!sanitized) return DEFAULT_COOKIE_NAME;
    return sanitized.slice(0, 64);
  }

  function sanitizeMinimizeDays(days) {
    var parsed = parseInt(days, 10);
    if (isNaN(parsed) || parsed < 1) return 7;
    return Math.min(parsed, MAX_MINIMIZE_DAYS);
  }

  function hasCookie(name) {
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < cookies.length; i++) {
      var eq = cookies[i].indexOf('=');
      if (eq > -1 && cookies[i].slice(0, eq) === name) return true;
    }
    return false;
  }

  function setCookie(name, days) {
    var safeName = sanitizeCookieName(name);
    var maxAge = sanitizeMinimizeDays(days) * 60 * 60 * 24;
    var cookie = safeName + '=1; Max-Age=' + maxAge + '; Path=/; SameSite=Lax';
    if (window.location.protocol === 'https:') cookie += '; Secure';
    document.cookie = cookie;
  }

  function clearCookie(name) {
    var safeName = sanitizeCookieName(name);
    var cookie = safeName + '=; Max-Age=0; Path=/; SameSite=Lax';
    if (window.location.protocol === 'https:') cookie += '; Secure';
    document.cookie = cookie;
  }

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  class Leadmagnet extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      // Inline variant (mobile drawer teaser) has no close/peek controls
      // and no cookie-based minimize behaviour. Skip wiring entirely.
      if (this.dataset.mode === 'inline') return;
      this._wired = true;

      this._cookieName = sanitizeCookieName(this.dataset.cookieName || DEFAULT_COOKIE_NAME);
      this._minimizeDays = sanitizeMinimizeDays(this.dataset.minimizeDays || '7');

      this._closeBtn = this.querySelector('[data-leadmagnet-close]');
      this._peekBtn = this.querySelector('[data-leadmagnet-peek]');
      this._backdrop = document.querySelector(
        '[data-leadmagnet-backdrop][data-target="' + this.id + '"]'
      );

      if (this._closeBtn) {
        this._closeBtn.addEventListener('click', this._onClose.bind(this));
      }
      if (this._peekBtn) {
        this._peekBtn.addEventListener('click', this._onPeek.bind(this));
      }
      if (this._backdrop) {
        this._backdrop.addEventListener('click', this._onClose.bind(this));
      }

      if (isDesignMode()) {
        this.expand(false);
      } else if (hasCookie(this._cookieName)) {
        this.minimize(false);
      } else {
        this.expand(false);
      }

      this.hidden = false;
    }

    _onClose(e) {
      e.preventDefault();
      this.minimize(true);
    }

    _onPeek(e) {
      e.preventDefault();
      this.expand(true);
    }

    minimize(persist) {
      if (persist !== false && !isDesignMode()) {
        setCookie(this._cookieName, this._minimizeDays);
      }
      this.dataset.state = 'minimized';
      if (this._peekBtn) {
        this._peekBtn.setAttribute('aria-expanded', 'false');
      }
    }

    expand(clearMinimizeCookie) {
      if (clearMinimizeCookie !== false && !isDesignMode()) {
        clearCookie(this._cookieName);
      }
      this.dataset.state = 'expanded';
      if (this._peekBtn) {
        this._peekBtn.setAttribute('aria-expanded', 'true');
      }
    }

    getState() {
      return this.dataset.state === 'minimized' ? 'minimized' : 'expanded';
    }
  }

  if (!customElements.get('lead-magnet')) {
    customElements.define('lead-magnet', Leadmagnet);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('lead-magnet').forEach(function (el) {
      if (!(el instanceof Leadmagnet) || el._wired) return;
      el.connectedCallback();
    });
  }

  function getInstance(el) {
    if (!el || !(el instanceof Leadmagnet)) return null;
    return el;
  }

  window.HakroLeadmagnet = {
    VERSION: VERSION,
    init: init,
    getInstance: getInstance,
    Leadmagnet: Leadmagnet,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
